"use client";

import type { FC, PropsWithChildren } from "react";
import React, { useContext } from "react";

import type { Language } from "../config/config.types";

export type LanguageModel = Language[];

type LanguageProviderProps = PropsWithChildren<{ model: LanguageModel }>;

const LanguageContext = React.createContext<LanguageModel>([]);

export const LanguagesProvider: FC<LanguageProviderProps> = ({ children, model }) => {
  return <LanguageContext.Provider value={model}>{children}</LanguageContext.Provider>;
};

export const useLanguages = (): LanguageModel => {
  return useContext(LanguageContext);
};
